export type KissDatepickerOnDateChangeEvent = Date | Date[];
